module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/sSdgIcon-9b03d3c9ddac3c3d53b60a4ad686c687.png";